import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Card from "src/components/Card";
import Tabs from "src/components/layout/Tabs";
import RegistrationSelectList from "src/components/lists/RegistrationSelectList";
import TaskMatchProgress from "src/components/tasks/TaskMatchProgress";
import useTask from "src/hooks/api/tasks/useTask";
import useWindowSize from "src/hooks/useWindowSize";

const RegistrationsSidebar = () => {
	const { t } = useTranslation("registrations", {
		keyPrefix: "registrations-sidebar",
	});
	const states = {
		all: t("tabs.all"),
		accepted: t("tabs.accepted"),
		open: t("tabs.open"),
		denied: t("tabs.denied"),
	} as any;
	const { id, registration } = useParams() as any;
	const { isTablet } = useWindowSize();
	const { task } = useTask();

	return (
		<>
			{(!isTablet || (!registration && isTablet)) && (
				<div
					className={`w-full sticky-0 flex flex-col flex-1 h-full ${
						!isTablet && "max-w-[400px]"
					}`}
				>
					<Card type="no-padding" className="flex-1 h-full">
						<div className="pb-4 px-6 pt-6">
							<TaskMatchProgress
								matched={task?.matches?.count}
								students={task?.amount_of_students}
							/>
						</div>
						<div className="flex flex-col flex-1 relative">
							<div className="absolute inset-0 overflow-auto hide-scrollbar">
								<Tabs
									options={{
										small: true,
										rememberKey: `registrations-${id}`,
										noBackground: true,
									}}
									tabs={Object.values(states)}
									spacing={{
										horizontal: 4,
									}}
									actions={{
										left: (
											<div>
												<div className="block w-4"></div>
											</div>
										),
									}}
								>
									{(tab) => {
										const state =
											Object.keys(states).find(
												(key) => states[key] === tab
											) || "all";
										return (
											<div className="md:px-6">
												<RegistrationSelectList
													limit={8}
													task={id}
													query={`state=${state}`}
												/>
											</div>
										);
									}}
								</Tabs>
							</div>
						</div>
					</Card>
				</div>
			)}
		</>
	);
};

export default RegistrationsSidebar;
